import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import Login from "../../components/Auth/Login"
import Alert from "../../components/utils/Alert/Alert"
import { setStatus } from "../../redux/slices/auth/authSlice"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { useTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import Skeleton from "@/components/common/skeleton"
import success from "@/assets/images/welcomenn.svg" // Adjust the path as necessary
import invitesmart from "@/assets/images/invitesmart.svg" // Adjust the path as necessary
const statusesAlert = ["FORGOT-PASSWORD-SUCCESS", "SIGNUP-SUCCESS"]

const LoginPage = () => {
  const { t } = useTranslation()
  const { status, error, accessToken } = useAppSelector((state) => state.auth)
  const [isLoadingImage, setIsLoadingImage] = useState(true)

  const handleImageLoad = () => {
    setIsLoadingImage(false)
  }
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  // useEffect(() => {
  //   if (accessToken) {
  //     navigate("/")
  //   }

  //   return () => {
  //     if (error) {
  //       dispatch(setError(""))
  //     }
  //   }
  // }, [accessToken, error])

  return (
    <>
      <div className="container mb-3 ">
        <Link
          className="d-flex align-items-center reminders-page__link-container"
          to="/welcome"
        >
          <IconArrowLeft />
          <span className="reminders-page__link-text">
            {t("buttons.backNew")}
          </span>
        </Link>
      </div>{" "}
      {status && statusesAlert.includes(status) && (
        <Alert
          status={status}
          onClose={() => {
            dispatch(setStatus(""))
          }}
        />
      )}
      <div className=" row w-100 d-flex justify-content-center ">
        <div className="col-12 col-md-6  col-lg-5 ps-5 d-none d-md-block   pe-5 me-md-0 ms-md-0 justify-content-center">
          <div className="d-flex  mb-1 justify-content-start  justify-content-start  m-0 p-0"></div>
          <div
            className="d-flex  mb-1 align-items-center  justify-content-start   m-0 p-0 "
            style={{ minHeight: "300px" }}
          >
            {/* {isLoadingImage && (
              <Skeleton width="350px" height="400px" borderRadius="8px" />
            )} */}
            <img
              src={success}
              // width="100%"
              // height="400px"
              style={{
                maxHeight: "370px",
                maxWidth: "370px",
                objectFit: "contain",
                // display: isLoadingImage ? "none" : "flex",
                display: "flex",
              }}
              // onLoad={handleImageLoad}
            />
          </div>{" "}
          <div
            className="mb-1 d-flex flex-column gap-1 align-items-start justify-content-start   m-0 p-0 "
            // style={{ maxWidth: "350px" }}
          >
            <h5 className=" fs-1 text-dark text-capitalize mb-2">
              {t("welcome.welcomeBack")}
            </h5>
            <h5
              className="text-muted fw-bold    mb-2 "
              style={{ color: "#6D717A", fontFamily: "Inter" }}
            >
              {t("welcome.yourSourceForPersonalInvitations")}
            </h5>
            <h5
              className="text-muted  "
              style={{
                fontFamily: "Inter",
                color: "#6D717A",
                fontSize: "1.0rem",
              }}
            >
              {t("welcome.whatWeOffer")}
            </h5>
          </div>
        </div>
        <div className=" col-12 col-md-6  col-lg-6 login   row p-sm-4 px-2 py-3 ">
          <div className="login w-100 p-sm-4 px-2 py-3 mx-auto">
            <h2
              className="login__title w-100 text-center"
              style={{ color: "#245192" }}
            >
              {t("login.title")}
            </h2>
            <Login />
          </div>
        </div>
      </div>
      {/* <ToastContainer
        style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
      /> */}
    </>
  )
}

export default LoginPage
